const env = {};
// 维护存储的key
export const ENV_kEYS = {
  userInfo: 'userInfo',
  featureAuth: 'featureAuth',
  userAuthCountry: 'userAuthCountry',
};
/**
 * 简单的仓库函数
 * @returns {{set: set, get: (function(*))}}
 */
function initEnv() {
  return {
    key: ENV_kEYS,
    set: (id, opts) => {
      env[id] = opts;
    },
    get: (id) => {
      return env[id] || {};
    },
    update: (id, opts) => {
      env[id] = {
        ...env[id],
        ...opts,
      };
    },
  };
}

export default initEnv();
